import Complaints from "../../Complaints/Complaints.jsx";


export function ProposalPopup({proposal, configuration, popupVisible, setPopupVisible, answeredChoice}) {

    let imageStyles = '';
    if (proposal.image) {
        imageStyles = <style>{`
            @media only screen and (min-width: 577px) {
                .proposal-text {
                    background-image:
                    linear-gradient(to right, rgba(243,245,248,1) 55%, rgba(255,255,255,0) 100%),
                    url(${proposal.image});
                    background-size: cover;
                    background-position: center;
                }
            }

            @media only screen and (max-width: 576px) {
                .proposal-text {
                    background-image:
                    linear-gradient(to right, rgba(243,245,248,1) 55%, rgba(255,255,255,0) 100%);
                }
            }`}
        </style>
    }

    let answerButtons = "";
    if (configuration.enableAnswerButtons) {
        answerButtons = (
            <form onSubmit={() => setPopupVisible(false)}>
                <input type="hidden" name="proposal" value={proposal.pk} />

                <button
                    className={answeredChoice === true ? 'proposal-info-close choosen-answer' : 'proposal-info-close'}
                    type="submit"
                    name="answer"
                    value="1"
                    title={configuration.translations.Yes}
                >
                    <i className="icon-mano_arriba" title={configuration.translations.Yes}></i>
                </button>
                <button
                    className={answeredChoice === false ? 'proposal-info-close choosen-answer' : 'proposal-info-close'}
                    type="submit"
                    name="answer"
                    value="0"
                    title={configuration.translations.No}
                >
                    <i className="icon-mano_abajo" title={configuration.translations.No}></i></button>
            </form>
        )
    }

    let shareButton = '';
    if (configuration.enableShareButtons) {
        function shareClick(event) {
            document.querySelector(`#proposal-${proposal.pk} .share-modal`).classList.add('visible');
        }

        shareButton = (
            <button
                type="button"
                className="share-proposal"
                onClick={shareClick}
                title={configuration.translations.shareButton}>
                <i className="icon-compartir" title={configuration.translations.shareButton}></i>
            </button>
        )
    }

    function closePopup() {
        setPopupVisible(false);
    }

    let popupClasses = "proposal-info-wrapper fullscreen-wrapper";
    if (popupVisible) popupClasses += ' popup-visible';

    return (
        <div id={`popup-proposal-${proposal.pk}`} className={popupClasses}>
            <article className="proposal-detail fullscreen-content">
                {imageStyles}
                <div className="proposal-text">
                    <div className="botonesPop">
                        <button type="button" className="close" onClick={closePopup} title={configuration.translations.closeButton}>
                            <i className="icon-cruz"></i>
                        </button>
                        <div className="botonInterior">
                            <i className="icon-proposal"></i>
                            {configuration.translations.proposalsTitle}
                        </div>
                    </div>
                    <h1>{proposal.name}</h1>
                    <div className="proposal-body" dangerouslySetInnerHTML={{ __html: proposal.body}}></div>
                </div>
                <div className="proposal-info-answer">
                    <a href={configuration.homeUrl} className="logo">{configuration.branding.name}</a>
                    <div>
                        {answerButtons}
                        {shareButton}
                        <Complaints id={proposal.pk} csrfToken={configuration.csrfToken}/>
                    </div>
                </div>
            </article>
        </div>
    )
    
}
